import { useState, useEffect } from 'react';

export function useInstallPrompt() {
  const [prompt, setPrompt]       = useState(null);
  const [installed, setInstalled] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => !!localStorage.getItem('tt_pwa_dismissed')
  );

  useEffect(() => {
    // Already running as installed PWA
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setInstalled(true); return;
    }
    if (window.navigator.standalone === true) { // iOS
      setInstalled(true); return;
    }

    const handler = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', () => { setInstalled(true); setPrompt(null); });

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!prompt) return false;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    setPrompt(null);
    return outcome === 'accepted';
  };

  const dismiss = () => {
    localStorage.setItem('tt_pwa_dismissed', '1');
    setDismissed(true);
    setPrompt(null);
  };

  const showBanner = !!prompt && !installed && !dismissed;

  return { prompt, installed, dismissed, showBanner, install, dismiss };
}
